import { TableColumnSortDirection } from '@percent/lemonade'

const MAX_PAGE_SIZE = 10

export const createQueryParams = (direction: TableColumnSortDirection) => ({
  pageSize: MAX_PAGE_SIZE,
  withForm: true,
  status: 'todo' as const,
  sortBy: 'due_by_date' as const,
  direction
})
